import Boxes from './Boxes';
import Environment from './Environment';

export default socketMiddleware => {
    return Object.assign({}, Environment(socketMiddleware), Boxes(socketMiddleware));
};



// WEBPACK FOOTER //
// ./environments/testbench/eventsSocket/index.js